import React, { useRef, useState, useEffect } from "react";
import "./callWhatsappButtons.css";
import { FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
// function CallButton() {
//   const buttonRef = useRef(null);
//   const [position, setPosition] = useState({
//     x: window.innerWidth - 80, // 20px from right
//     y: window.innerHeight - 100, // 100px from bottom
//   });
//   const dragStart = useRef({ x: 0, y: 0 });
//   const dragged = useRef(false);

//   useEffect(() => {
//     const button = buttonRef.current;
//     if (!button) return;

//     const handleTouchStart = (e) => {
//       const touch = e.touches[0];
//       dragStart.current = { x: touch.clientX, y: touch.clientY };
//       dragged.current = false;
//     };

//     const handleTouchMove = (e) => {
//       const touch = e.touches[0];
//       const deltaX = Math.abs(touch.clientX - dragStart.current.x);
//       const deltaY = Math.abs(touch.clientY - dragStart.current.y);
//       if (deltaX > 5 || deltaY > 5) {
//         dragged.current = true;
//         setPosition({
//           x: touch.clientX - 30,
//           y: touch.clientY - 30,
//         });
//       }
//     };

//     const handleTouchEnd = (e) => {
//       // Do nothing here; click handler will check `dragged.current`
//     };

//     const handleMouseDown = (e) => {
//       dragStart.current = { x: e.clientX, y: e.clientY };
//       dragged.current = false;
//       const moveHandler = (moveEvent) => {
//         const deltaX = Math.abs(moveEvent.clientX - dragStart.current.x);
//         const deltaY = Math.abs(moveEvent.clientY - dragStart.current.y);
//         if (deltaX > 5 || deltaY > 5) {
//           dragged.current = true;
//           setPosition({
//             x: moveEvent.clientX - 30,
//             y: moveEvent.clientY - 30,
//           });
//         }
//       };
//       const upHandler = () => {
//         window.removeEventListener("mousemove", moveHandler);
//         window.removeEventListener("mouseup", upHandler);
//       };
//       window.addEventListener("mousemove", moveHandler);
//       window.addEventListener("mouseup", upHandler);
//     };

//     button.addEventListener("touchstart", handleTouchStart);
//     button.addEventListener("touchmove", handleTouchMove);
//     button.addEventListener("touchend", handleTouchEnd);
//     button.addEventListener("mousedown", handleMouseDown);

//     return () => {
//       button.removeEventListener("touchstart", handleTouchStart);
//       button.removeEventListener("touchmove", handleTouchMove);
//       button.removeEventListener("touchend", handleTouchEnd);
//       button.removeEventListener("mousedown", handleMouseDown);
//     };
//   }, []);

//   const handleClick = () => {
//     if (!dragged.current) {
//       window.location.href = "tel:+14167356453";
//     }
//   };

//   return (
//     <div
//       className="draggable-call-button"
//       ref={buttonRef}
//       onClick={handleClick}
//       style={{
//         left: position.x,
//         top: position.y,
//         position: "fixed",
//       }}
//     >
//       <FaPhoneAlt size={28} color="white" />
//     </div>
//   );

// }

function CallButton() {
  return (
    <div>
      <a className="call-button" href="tel:+14167356453">
        <FiPhone size={28} />
      </a>
    </div>
  );
}

function WhatsappButton() {
  return (
    <div>
      <a
        className="whats-button"
        href="https://wa.me/14167356453"
        target="_blank"
      >
        <FaWhatsapp size={28} color="white" />
      </a>
    </div>
  );
}

export { CallButton, WhatsappButton };
